module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-grid-multi-e172bc941fb9baa49badaafc1469f141.png";